import * as yup from 'yup';

function repairCategory(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'EDITFORM_REPAIRSEVERITY_FIELD_IS_REQUIRED',
        defaultMessage: 'Repair Category is required',
      }),
    )
    .max(
      64,
      formatMessage({
        id: 'EDITFORM_REPAIRSEVERITY_FIELD_MAX_CHARS_64',
        defaultMessage: 'Repair Category should be less than 64 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'EDITFORM_STATUS_FIELD_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      repairCategory: repairCategory(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
